import { api } from "@/lib/api";

/** Заметки и задачи (backend/hub/api/activity.py): к контакту, сделке или компании. Из Zoho CRM — синхронизацией; правка в Hub главнее. */

export type Ref = { id: string; name: string } | null;

export type Note = {
  id: string;
  title: string;
  body: string;
  authorId: string | null;
  author: string;
  fromCrm: boolean;
  createdAt: string;
  updatedAt: string;
  contactId: string | null;
  contact: Ref;
  dealId: string | null;
  deal: { id: string; title: string } | null;
  companyId: string | null;
  company: Ref;
};

export type TaskStatus = "open" | "done" | "deferred";
export type TaskPriority = "low" | "normal" | "high";

export type Task = {
  id: string;
  title: string;
  description: string;
  status: TaskStatus;
  priority: TaskPriority;
  dueDate: string | null;
  overdue: boolean;
  assigneeId: string | null;
  assignee: string;
  createdBy: string | null;
  fromCrm: boolean;
  closedAt: string | null;
  createdAt: string;
  updatedAt: string;
  contactId: string | null;
  contact: Ref;
  dealId: string | null;
  deal: { id: string; title: string } | null;
  companyId: string | null;
  company: Ref;
};

export type Parent = { contactId?: string | null; dealId?: string | null; companyId?: string | null };

export type TaskInput = Partial<{
  title: string;
  description: string;
  status: TaskStatus;
  priority: TaskPriority;
  dueDate: string | null;
  contactId: string | null;
  dealId: string | null;
  companyId: string | null;
  assigneeId: string | null;
}>;

export type TaskQuery = { scope?: string; status?: string; contact?: string; deal?: string; company?: string; due?: string; q?: string; page?: number; size?: number };

const qs = (o: Record<string, unknown>) => {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(o)) if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
  const s = p.toString();
  return s ? `?${s}` : "";
};

const parentQuery = (p: Parent) => ({ contact: p.contactId ?? "", deal: p.dealId ?? "", company: p.companyId ?? "" });

export const notesApi = {
  list: (p: Parent, limit = 100) => api<Note[]>(`/notes${qs({ ...parentQuery(p), limit })}`),
  create: (p: Parent, body: string, title = "") => api<Note>("/notes", { method: "POST", json: { ...p, body, title } }),
  update: (id: string, body: string) => api<Note>(`/notes/${id}`, { method: "PATCH", json: { body } }),
  remove: (id: string) => api(`/notes/${id}`, { method: "DELETE" }),
};

export const tasksApi = {
  list: (q: TaskQuery = {}) => api<{ items: Task[]; total: number; mine: { overdue: number; today: number; open: number } }>(`/tasks${qs(q)}`),
  create: (body: TaskInput) => api<Task>("/tasks", { method: "POST", json: body }),
  update: (id: string, body: TaskInput) => api<Task>(`/tasks/${id}`, { method: "PATCH", json: body }),
  remove: (id: string) => api(`/tasks/${id}`, { method: "DELETE" }),
};

/** открыть раздел «Задачи» с готовой формой новой задачи (из карточки контакта/сделки) */
let pendingNew: TaskInput | null = null;
export const showNewTask = (draft: TaskInput) => {
  pendingNew = draft;
};
export const takeNewTask = () => {
  const d = pendingNew;
  pendingNew = null;
  return d;
};
